<template>
  <el-table
    v-bind="$attrs"
    ref="tableRef"
    style="width: 100%"
    v-loading="loading"
    :data="data"
    :current-columns="currentColumns"
    :element-loading-text="loadingText"
    v-on="$listeners"
    @scroll="onScroll"
    @filter-change="onFilterChange"
  >
    <el-table-column v-for="(column, index) in currentColumns" v-bind="column" :key="column._key || column.label || index" :prop="column.key" v-on="column">
      <!-- 有header的 情况 -->
      <template v-if="column.renderHeader" #header="params">
        <RenderDom :key="index" :props="params" :render="column.renderHeader" />
      </template>
      <!-- 有render的情况 -->
      <template v-if="column.render" #default="params">
        <!-- 加载图片 -->
        <!-- <el-image :src="column.imageSrc"  /> -->
        <RenderDom :key="index" :props="params" :render="column.render" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import RenderDom from '@/utils/renderDom'
import { getPropByPath } from 'element-ui/src/utils/util'

export default {
  name: 'BaseTable',
  components: {
    RenderDom
  },
  props: {
    // 表格配置项
    columns: {
      type: Array,
      default: () => []
    },
    // 表格数据
    data: {
      type: Array,
      default: () => []
    },
    /**
     * @description 转换的日期格式
     */
    formatDate: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingText: '拼命加载中'
    }
  },
  computed: {
    /**
     * @description 对传入进来的columns 进行一些预处理
     */
    currentColumns() {
      const columns = this.columns.filter((obj) => obj.show !== false)
      const currentColumns = columns.map((column) => {
        const data = cloneDeep(column)
        data['show-overflow-tooltip'] = column['show-overflow-tooltip'] === undefined ? true : column['show-overflow-tooltip']
        data.align = data.align || 'center'

        const { type, key, render, gatherKey, dataEnum, copy,keyGroup = [],suffixText = '' } = column

        // 单元格copy组件
      
        // key组合模式
        if (type === 'keyGroup') {
          data.render = (h,params)=>{
            const names = keyGroup.map((key) =>{
              return params.row[key]
            }) 
            return <div>{names.join('-')}</div>
          }
        
        }
        // 时间展示 如果没有render 并且key 存在
        if (type === 'date' && key && !render) {
          data.render = (h, params) => {
            return <span>{dayjs(params.row[key]).format(column.formatDate || this.formatDate)}</span>
          }
        }
        // 数据拆分展示 如 [ 1，2，3，4 ] => 1,2,3,4
        if (type === 'gather' && key) {
          data.render = (h, params) => {
            //   判断当前数组是一个二维数组 还是三维数组
            if (!params.row[key][gatherKey]) {
              return <span> {params.row[key].join(', ')} </span>
            }
            return <span>{params.row[key].map((data) => data[gatherKey]).join('/ ')}</span>
          }
        }
        // 开关
        if (type === 'switch' && key) {
          const activeValue = column.activeValue || true
          const inactiveValue = column.inactiveValue || false
          data.render = (h, params) => {
            return (
              <el-switch
                value={params.row[key]}
                active-value={activeValue}
                inactive-value={inactiveValue}
                active-color="#13ce66"
                inactive-color="#ff4949"
                disabled={typeof column.disabled === 'function' ? column.disabled(params) : column.disabled}
                on-change={(val) => column.change(val, params)}
              ></el-switch>
            )
          }
        }
        // 枚举类型
        if (type === 'enum' && key) {
          data.render = (h, params) => {
            // 这样改是为了解决多层嵌套的问题，例如template_info.delivery_mode
            const prop = getPropByPath(params.row, key, true)
            return <div>{dataEnum[prop.o[prop.k]] ? dataEnum[prop.o[prop.k]] : '/'}</div>
          }
        }
        // href 需要跳转的
        if (type === 'link') {
          // 判断是否有render
          data.render = (h, params) => {
            return (
              <el-link type="primary" underline={false} onClick={() => column.click && column.click(params)}>
                {params.row[key]}
              </el-link>
            )
          }
        }
        // 后缀 没有render的情况下 且又后缀的情况下
        if (suffixText && data.render === undefined)  {
            data.render = (h,params)=>{
              return (
                <span>
                  {params.row[key]}
                  {params.row[key] && Number(params.row[key]) ? suffixText : ''}
                </span>
              )
            }
        }
        return data
      })

      // 过滤隐藏的
      return currentColumns.filter((column) => column.show !== false)
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        setTimeout(() => {
          if (this.loading) this.loading = false
        }, 300000) // 最大5分钟
      }
    }
  },
  updated() {
    // 这里不能用防抖或者是节流 会有延迟
    this.tableDoLayout()
  },
  mounted() {
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     try {
    //       const node = this.$refs.tableRef?.$refs.bodyWrapper
    //       node.addEventListener(
    //         'scroll',
    //         this.$utils.debounce(() => {
    //           this.tableDoLayout()
    //         }, 100)
    //       )
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }, 100)
    // })
  },
  beforeDestroy() {
    // try {
    //   const node = this.$refs.tableRef?.$refs.bodyWrapper
    //   node.addEventListener(
    //     'scroll',
    //     this.$utils.debounce(() => {
    //       this.tableDoLayout()
    //     }, 100)
    //   )
    // } catch (error) {
    //   console.log(error)
    // }
  },
  methods: {
    /** 获取value值  */
    getCurrentValue(data,column){
      // 如果不需要下一级value获取
      if (!column.key.includes('.')) return data[column.key]
      // 如果是层级value
      const prop = getPropByPath(data, column.key, true)
      return prop.o[prop.k]
    },
    // 调用 ref.tableRef 的内置方法
    callBuiltInMethod (fn) {
      if (typeof this.$refs.tableRef[fn] === 'function') {
        this.$refs.tableRef[fn]()
      }
    },
    clearSort(){
      this.$refs.tableRef.clearSort()
    },
    /** 获取唯一key  用来循环的 */
    getKey(item, index) {
      return item.label || item.key || index
    },
    // 调用表格的 doLayout
    tableDoLayout() {
      this.$refs.tableRef && this.$refs.tableRef.doLayout()
    },
    onScroll() {
      console.log('滚动了')
    },
    // 表头筛选
    onFilterChange () {
      this.$emit('update:page', 1)
      this.$emit('filterChange')
    }
  }
}
</script>
